import { Alert, DialogActions, DialogContent, DialogTitle, Stack, TextField } from "@mui/material";
import { Localized } from "@fluent/react";
import { useState } from "react";
import { useAppDispatch } from "../../../app/hooks";
import { AppUser, updateUserPersonalData } from "../administration";
import { CancelButton } from "../../../app/components/CancelButton";
import { SaveButton } from "../../../app/components/SaveButton";

export interface ChangePersonalDataDialogProps {
    user: AppUser;
    onSuccessfullySaved: (update: AppUser | undefined) => void;
    onCancel: () => void;
}

export const ChangePersonalDataDialog = ({ user, onSuccessfullySaved, onCancel }: ChangePersonalDataDialogProps) => {
    const dispatch = useAppDispatch();
    const [firstName, setFirstName] = useState(user.firstName);
    const [surname, setSurname] = useState(user.surname);
    const [position, setPosition] = useState(user.position);
    const [password, setPassword] = useState("");
    const [saving, setSaving] = useState(false);
    const [serverError, setServerError] = useState("");

    const handleSave = async () => {
        if (!firstName.trim() || !surname.trim() || !password) {
            setServerError("");
            return;
        }

        setSaving(true);
        setServerError("");
        try {
            const updatedUser = await dispatch(updateUserPersonalData({
                ...user,
                firstName: firstName.trim(),
                surname: surname.trim(),
                position: position.trim(),
                password,
            }));

            if(updateUserPersonalData.fulfilled.match(updatedUser)) {
                onSuccessfullySaved(updatedUser.payload);
            } else {
                let errorMsg = "error"
                if (updatedUser.payload && updatedUser.payload.kind === 'http') {
                    const problem = updatedUser.payload.problem
                    if (problem) {
                        errorMsg = problem.title

                    }
                }
                setServerError(errorMsg)
            }
        } catch {
            setServerError("error");
        } finally {
            setSaving(false);
        }
    };

    return <>
        <DialogTitle>
            <Localized id="change-personal-data">Zmień dane osobowe</Localized>
        </DialogTitle>
        <DialogContent dividers>
            <Stack spacing={2} sx={{ pt: 1 }}>
                <TextField
                    label={<Localized id="user-first-name">Imię</Localized>}
                    value={firstName}
                    onChange={(event) => setFirstName(event.target.value)}
                    required
                    fullWidth
                    autoFocus
                />
                <TextField
                    label={<Localized id="user-last-name">Nazwisko</Localized>}
                    value={surname}
                    onChange={(event) => setSurname(event.target.value)}
                    required
                    fullWidth
                />
                <TextField
                    label={<Localized id="user-position">Stanowisko</Localized>}
                    value={position}
                    onChange={(event) => setPosition(event.target.value)}
                    fullWidth
                />
                <TextField
                    label={<Localized id="password">Hasło</Localized>}
                    value={password}
                    onChange={(event) => setPassword(event.target.value)}
                    type="password"
                    required
                    fullWidth
                    autoComplete="current-password"
                    helperText={<Localized id="personal-data-password-confirmation">_Potwierdź zmianę swoim hasłem</Localized>}
                />
                {
                    serverError && <Alert sx={{ marginTop: 1, }} onClose={() => { setServerError("") }} severity="error">
                        <Localized id={serverError}>
                            <span>Server error</span>
                        </Localized>
                    </Alert>
                }
            </Stack>
        </DialogContent>
        <DialogActions>
            <SaveButton loading={saving} onClick={handleSave}/>
            <CancelButton loading={saving} onClick={onCancel}/>
        </DialogActions>
    </>;
}